module.exports = __webpack_public_path__ + "static/media/728x90.278b58ef.png";